// Oauth
const OAUTH_API = 'oauth-api' as string;
const OAUTH_AUTHORIZE = 'oauth-authorize' as string;
const OAUTH_SIGNUP = 'oauth-signup' as string;
const OAUTH_PWDRECOVERY = 'oauth-password-recovery' as string;
const OAUTH_PWDRECOVERY_CLOSE = 'oauth-password-recovery-close' as string;
const OAUTH_ERROR = 'oauth-error' as string;

export default [
  OAUTH_API,
  OAUTH_SIGNUP,
  OAUTH_PWDRECOVERY,
  OAUTH_AUTHORIZE,
  OAUTH_ERROR,
  OAUTH_PWDRECOVERY_CLOSE,
] as const;
